const regex = /(option)|value=|"|'|<| |(\r\n|\r|\n)/gi

const newData = `<option value="0.0784455113860095">1209</option>
<option value="0.080467245646212">1210</option> '
<option value="0.0903020237897684">1211</option>' 
<option value="0.0791727935578819">1212</option>' 
<option value="0.0765050235871713">1213</option>' 
<option value="0.0739271455641463">1214</option>' 
<option value="0.0786163387647814">1215</option>' 
<option value="0.0836029671322296">1216</option>' 
<option value="0.0967946167398747">1217</option>' 
<option value="0.112881143895319">1218</option> '
<option value="0.109347083598048">1219</option> '
<option value="0.0954913361377302">1220</option>' 
<option value="0.106909392622481">1221</option> '
<option value="0.0902712343022248">1222</option>' 
<option value="0.0762224491464712">1223</option>' 
<option value="0.0840935860068789">1224</option>' 
<option value="0.125851734190799">1225</option> '
<option value="0.113814726264823">1226</option> '
<option value="0.113829651045191">1227</option> '
<option value="0.111766059090098">1228</option> '
<option value="0.109739877526042">1229</option> '
<option value="0.107750428148518">1230</option> '
<option value="0.10579704504804">1231</option> '
<option value="0.10387907438724">1232</option> '
<option value="0.0976791748924056">1233</option>' 
<option value="0.0985057436538083">1234</option>' 
<option value="0.0993393069042418">1235</option>' 
<option value="0.0965120083552675">1236</option>' 
<option value="0.106389886062084">1237</option> '
<option value="0.103368105238218">1238</option> '
<option value="0.100432151739536">1239</option> '
<option value="0.0975795878214859">1240</option>' 
<option value="0.0948080449785158">1241</option>' 
<option value="0.0921152219774911">1242</option>' 
<option value="0.0894988829469617">1243</option>' 
<option value="0.0869568555207006">1244</option>' 
<option value="0.0844870290339718">1245</option>' 
<option value="0.097285492735599">1246</option> '
<option value="0.128768598434498">1247</option> '
<option value="0.127139643452501">1248</option> '
<option value="0.094007404446843">1249</option> '
<option value="0.102896253805356">1250</option> '
<option value="0.0960596899376226">1251</option>' 
<option value="0.0987680950798849">1252</option>' 
<option value="0.113533028372591">1253</option> '
<option value="0.0867390349975951">1254</option>' 
<option value="0.08913885211693">1255</option> '
<option value="0.113501556069349">1256</option> '
<option value="0.131564531850493">1257</option> '
<option value="0.129369637247357">1258</option> '
<option value="0.123518202942376">1259</option> '
<option value="0.110149464055807">1260</option> '
<option value="0.11676297849217">1261</option> '
<option value="0.118335759828969">1262</option> '
<option value="0.10639256689122">1263</option> '
<option value="0.108285363750506">1264</option> '
<option value="0.112239154329622">1265</option> '
<option value="0.112930041978574">1266</option> '
<option value="0.121229507674074">1267</option> '
<option value="0.103571140057133">1268</option> '
<option value="0.123537852636563">1269</option> '
<option value="0.120957512546529">1270</option> '
<option value="0.152511076519165">1271</option> '
<option value="0.160230899878329">1272</option> '
<option value="0.132962349087437">1273</option> '
<option value="0.151028818798141">1274</option> '
<option value="0.147712179893072">1275</option> '
<option value="0.131737054738078">1276</option> '
<option value="0.149210313388917">1277</option> '
<option value="0.129101986463065">1278</option> '
<option value="0.11922988737378">1279</option> '
<option value="0.134963072018414">1280</option> '
<option value="0.126031085861322">1281</option> '
<option value="0.145612193790691">1282</option> '
<option value="0.140228639586706">1283</option> '
<option value="0.141214787582798">1284</option> '
<option value="0.118554709458266">1285</option> '
<option value="0.128153467627646">1286</option> '
<option value="0.115331399934431">1287</option> '
<option value="0.0944102302064068">1288</option>' 
<option value="0.102070685136061">1289</option> '
<option value="0.118777468675025">1290</option> '
<option value="0.139115822117935">1291</option> '
<option value="0.130075930219472">1292</option> '
<option value="0.130652403767218">1293</option> '
<option value="0.152245416822461">1294</option> '
<option value="0.158920733053944">1295</option> '
<option value="0.150821258211269">1296</option> '
<option value="0.129944148084084">1297</option> '
<option value="0.14041409197728">1298</option> '
<option value="0.140292752910515">1299</option> '
<option value="0.14379704702722">1300</option> '
<option value="0.135570189767008">1301</option> '
<option value="0.129410940325302">1302</option> '
<option value="0.122377141468023">1303</option> '
<option value="0.11729094554496">1304</option> '
<option value="0.130941189381433">1305</option> '
<option value="0.132680784630136">1306</option> '
<option value="0.126748794024357">1307</option> '
<option value="0.140952082611765">1308</option> '
<option value="0.163150191370587">1309</option> '
<option value="0.171979918391502">1310</option> '
<option value="0.17349589923449">1311</option> '
<option value="0.141779561291678">1312</option> '
<option value="0.13828112656609">1313</option> '
<option value="0.150130470399911">1314</option> '
<option value="0.160512212363783">1315</option> '
<option value="0.227260412193107">1316</option> '
<option value="0.231039190851343">1317</option> '
<option value="0.171840442918863">1318</option> '
<option value="0.129033846154293">1319</option> '
<option value="0.145154899615204">1320</option> '
<option value="0.155386117197784">1321</option> '
<option value="0.209543122640123">1322</option> '
<option value="0.180405856785168">1323</option> '
<option value="0.154104425784028">1324</option> '
<option value="0.1660323328215">1325</option> '
<option value="0.140844200902955">1326</option> '
<option value="0.122085804753268">1327</option> '
<option value="0.133498375722272">1328</option> '
<option value="0.147716564048652">1329</option> '
<option value="0.148539708646649">1330</option> '
<option value="0.15981363114939">1331</option> '
<option value="0.162901330415868">1332</option> '
<option value="0.134504801870546">1333</option> '
<option value="0.12680807288987">1334</option> '
<option value="0.125778518623615">1335</option> '
<option value="0.131551824775102">1336</option> '
<option value="0.123190340498152">1337</option> '
<option value="0.111277889648871">1338</option> '
<option value="0.101891332971492">1339</option> '
<option value="0.132733941194159">1340</option> '
<option value="0.113149510167336">1341</option> '
<option value="0.118454519020836">1342</option> '
<option value="0.11572906499787">1343</option> '
<option value="0.129404400987139">1344</option> '
<option value="0.114335082293964">1345</option> '
<option value="0.120248420160037">1346</option> '
<option value="0.147392879762602">1347</option> '
<option value="0.147083574311076">1348</option> '
<option value="0.117029321904636">1349</option> '
<option value="0.139960589380479">1350</option> '
<option value="0.16672003368918">1351</option> '
<option value="0.189806416667775">1352</option> '
<option value="0.149895094568502">1353</option> '
<option value="0.142009600612857">1354</option> '
<option value="0.148127237310111">1355</option> '
<option value="0.155511368219138">1356</option> '
<option value="0.160804577372665">1357</option> '
<option value="0.162526354333551">1358</option> '
<option value="0.15366493309414">1359</option> '
<option value="0.154966401922066">1360</option> '
<option value="0.154014796334267">1361</option> '
<option value="0.147304443086176">1362</option> '
<option value="0.170499764633161">1363</option> '
<option value="0.182217662106486">1364</option> '
<option value="0.165900463043288">1365</option> '
<option value="0.151974436063121">1366</option> '
<option value="0.155107814397934">1367</option> '
<option value="0.169646144861718">1368</option> '
<option value="0.169414512585444">1369</option> '
<option value="0.236353390212621">1370</option> '
<option value="0.174784249133156">1371</option> '
<option value="0.159135876735403">1372</option> '
<option value="0.174552469471424">1373</option> '
<option value="0.152992529662056">1374</option> '
<option value="0.180922783746672">1375</option> '
<option value="0.178085598055664">1376</option> '
<option value="0.139235728377127">1377</option> '
<option value="0.130678425662971">1378</option> '
<option value="0.124780625823855">1379</option> '
<option value="0.149877020838252">1380</option> '
<option value="0.152002567577424">1381</option> '
<option value="0.139988974343247">1382</option> '
<option value="0.138496938790289">1383</option> '
<option value="0.139614501197006">1384</option> '
<option value="0.134104024343779">1385</option> '
<option value="0.142068708803596">1386</option> '
<option value="0.132462467999885">1387</option> '
<option value="0.122919308412379">1388</option> '
<option value="0.11467354353428">1389</option> '
<option value="0.146304419569802">1390</option> '
<option value="0.171530350548139">1391</option> '
<option value="0.139120381713672">1392</option> '
<option value="0.120470857917155">1393</option> '
<option value="0.124230444133525">1394</option> '
<option value="0.128065710202839">1395</option> '
<option value="0.12898515824864">1396</option> '
<option value="0.151520251670576">1397</option> '
<option value="0.148235319988219">1398</option> '
<option value="0.141297883456098">1399</option> '
<option value="0.14511591372471">1400</option> '
<option value="0.155201327402228">1401</option> '
<option value="0.174585819514138">1402</option> '
<option value="0.154090287909934">1403</option> '
<option value="0.136381980126644">1404</option> '
<option value="0.13400616400329">1405</option> '
<option value="0.125098190279638">1406</option> '
<option value="0.134325409661784">1407</option> '
<option value="0.147056480589749">1408</option> '
<option value="0.159131764470949">1409</option> '
<option value="0.172934019707771">1410</option> '
<option value="0.149022420329501">1411</option> '
<option value="0.137874224108129">1412</option> '
<option value="0.138619807496106">1413</option> '
<option value="0.134531419820661">1414</option> '
<option value="0.136151298019669">1415</option> '
<option value="0.153037607392406">1416</option> '
<option value="0.166721639815334">1417</option> '
<option value="0.144935862507365">1418</option> '
<option value="0.152697327359709">1419</option> '
<option value="0.135216463284219">1420</option> '
<option value="0.146012734675539">1421</option> '
<option value="0.13889750702817">1422</option> '
<option value="0.128609472711132">1423</option> '
<option value="0.129734175430009">1424</option> '
<option value="0.139919736750599">1425</option> '
<option value="0.134385418198611">1426</option> '
<option value="0.128524236043434">1427</option> '
<option value="0.130574584850713">1428</option> '
<option value="0.163127386503354">1429</option> '
<option value="0.162022153689057">1430</option> '
<option value="0.144579007294488">1431</option> '
<option value="0.128194517720055">1432</option> '
<option value="0.155557636723599">1433</option> '
<option value="0.140934039834426">1434</option> '
<option value="0.134279451312982">1435</option> '
<option value="0.143454873838513">1436</option> '
<option value="0.140294255966246">1437</option> '
<option value="0.183601085893948">1438</option> '
<option value="0.192940814003238">1439</option> '
<option value="0.160628798670846">1440</option> '
<option value="0.121462373807403">1441</option> '
<option value="0.126138984799466">1442</option> '
<option value="0.128208345037842">1443</option> '
<option value="0.126596609907753">1444</option> '
<option value="0.120505008683734">1445</option> '
<option value="0.138735816485495">1446</option> '
<option value="0.143635739950532">1447</option> '
<option value="0.132208171306319">1448</option> '
<option value="0.137328802759713">1449</option> '
<option value="0.134175502138706">1450</option> '
<option value="0.139316363660055">1451</option> '
<option value="0.141634826543657">1452</option> '
<option value="0.137944369055377">1453</option> '
<option value="0.132352519063966">1454</option> '
<option value="0.125013929486895">1455</option> '
<option value="0.13227777854604">1456</option> '
<option value="0.134185112064401">1457</option> '
<option value="0.142664536802534">1458</option> '
<option value="0.140674470687785">1459</option> '
<option value="0.139060338300426">1460</option> '
<option value="0.156314884458122">1461</option> '
<option value="0.157142167105459">1462</option> '
<option value="0.125102406516376">1463</option> '
<option value="0.116453625048486">1464</option> '
<option value="0.128790880548909">1465</option> '
<option value="0.131624679405251">1466</option> '
<option value="0.138360372228511">1467</option> '
<option value="0.144636949779631">1468</option> '
<option value="0.142382355772983">1469</option> '
<option value="0.146147646135574">1470</option> '
<option value="0.146784952113532">1471</option> '
<option value="0.141879760806068">1472</option> '
<option value="0.128422709257244">1473</option> '
<option value="0.128069246547579">1474</option> '
<option value="0.128668913356354">1475</option> '
<option value="0.135792464296605">1476</option> '
<option value="0.13720004813633">1477</option> '
<option value="0.148047072083689">1478</option> '
<option value="0.149211662104323">1479</option> '
<option value="0.138524922835073">1480</option> '
<option value="0.139948039641318">1481</option> '
<option value="0.159120211057205">1482</option> '
<option value="0.178308477085254">1483</option> '
<option value="0.158795636671746">1484</option> '
<option value="0.139547093815507">1485</option> '
<option value="0.138719178896082">1486</option> '
<option value="0.14473072925489">1487</option> '
<option value="0.140955609122591">1488</option> '
<option value="0.143804945366821">1489</option> '
<option value="0.141968112955613">1490</option> '
<option value="0.150599210593401">1491</option> '
<option value="0.14614021808016">1492</option> '
<option value="0.135059415109982">1493</option> '
<option value="0.134935860074072">1494</option> '
<option value="0.131546971138079">1495</option> '
<option value="0.120631542198822">1496</option> '
<option value="0.146122108808047">1497</option> '
<option value="0.136573556379179">1498</option> '
<option value="0.139467931825524">1499</option> '
<option value="0.131290844197559">1500</option> '
<option value="0.154963856700484">1501</option> '
<option value="0.160993593259897">1502</option> '
<option value="0.14997263106718">1503</option> '
<option value="0.153031468180348">1504</option> '
<option value="0.141439239415791">1505</option> '
<option value="0.137019457774617">1506</option> '
<option value="0.142391230330246">1507</option> '
<option value="0.141691639897762">1508</option> '
<option value="0.118965357622154">1509</option> '
<option value="0.123547619352255">1510</option> '
<option value="0.127093424239462">1511</option> '
<option value="0.14438040070681">1512</option> '
<option value="0.170361864041605">1513</option> '
<option value="0.147503947406002">1514</option> '
<option value="0.147599791412971">1515</option> '
<option value="0.159005542280885">1516</option> '
<option value="0.138523900703463">1517</option> '
<option value="0.15467989121773">1518</option> '
<option value="0.155022646159106">1519</option> '
<option value="0.175714374508014">1520</option> '
<option value="0.187545559253366">1521</option> '
<option value="0.167741279540897">1522</option> '
<option value="0.166954010113964">1523</option> '
<option value="0.160918987098317">1524</option> '
<option value="0.14647942378871">1525</option> '
<option value="0.143673636967052">1526</option> '
<option value="0.162177947167464">1527</option> '
<option value="0.227483940974532">1528</option> '
<option value="0.183470372913219">1529</option> '
<option value="0.183624100255095">1530</option> '
<option value="0.18669059463951">1531</option> '
<option value="0.189875986004775">1532</option> '
<option value="0.186651944849068">1533</option> '
<option value="0.164593531537427">1534</option> '
<option value="0.18619166463707">1535</option> '
<option value="0.193478113651248">1536</option> '
<option value="0.195944153362976">1537</option> '
<option value="0.172061548827831">1538</option> '
<option value="0.164630042605768">1539</option> '
<option value="0.172734425237463">1540</option> '
<option value="0.187951393666946">1541</option> '
<option value="0.181969767650976">1542</option> '
<option value="0.196793850922414">1543</option> '
<option value="0.210248230907197">1544</option> '
<option value="0.238848172474628">1545</option> '
<option value="0.257909870970583">1546</option> '
<option value="0.190983777226036">1547</option> '
<option value="0.18818889400341">1548</option> '
<option value="0.235358118091246">1549</option> '
<option value="0.299032068257885">1550</option> '
<option value="0.330431873109409">1551</option> '
<option value="0.293124665616188">1552</option> '
<option value="0.264825565960414">1553</option> '
<option value="0.260777968394431">1554</option> '
<option value="0.311637406841188">1555</option> '
<option value="0.379146351222477">1556</option> '
<option value="0.405552901870413">1557</option> '
<option value="0.279074351472478">1558</option> '
<option value="0.299793979139105">1559</option> '
<option value="0.312399079633373">1560</option> '
<option value="0.342491058397643">1561</option> '
<option value="0.341771599917041">1562</option> '
<option value="0.35502480103231">1563</option> '
<option value="0.368579046481072">1564</option> '
<option value="0.313964579963707">1565</option> '
<option value="0.32475120215503">1566</option> '
<option value="0.301431281319323">1567</option> '
<option value="0.30313833114486">1568</option> '
<option value="0.329002065728093">1569</option> '
<option value="0.322584005323136">1570</option> '
<option value="0.310385703553341">1571</option> '
<option value="0.342022354948584">1572</option> '
<option value="0.359569014144666">1573</option> '
<option value="0.419376737623748">1574</option> '
<option value="0.364761810684677">1575</option> '
<option value="0.371383867578348">1576</option> '
<option value="0.402900075535373">1577</option> '
<option value="0.373211003598248">1578</option> '
<option value="0.373773519272706">1579</option> '
<option value="0.350180776888433">1580</option> '
<option value="0.402846799531092">1581</option> '
<option value="0.399880081627847">1582</option> '
<option value="0.380429797637191">1583</option> '
<option value="0.379470735672365">1584</option> '
<option value="0.403947210390073">1585</option> '
<option value="0.479229325264296">1586</option> '
<option value="0.478765706791565">1587</option> '
<option value="0.399232059718108">1588</option> '
<option value="0.41595630776539">1589</option> '
<option value="0.469041896720744">1590</option> '
<option value="0.463341548148337">1591</option> '
<option value="0.415588607659819">1592</option> '
<option value="0.435934827778497">1593</option> '
<option value="0.502695611281214">1594</option> '
<option value="0.561663559750933">1595</option> '
<option value="0.595209213442584">1596</option> '
<option value="0.6836815615083">1597</option> '
<option value="0.619473329641502">1598</option> '
<option value="0.505352389417524">1599</option> '
<option value="0.52372957761453">1600</option> '
<option value="0.527534661996758">1601</option> '
<option value="0.509715478893429">1602</option> '
<option value="0.483589665842221">1603</option> '
<option value="0.492645114082357">1604</option> '
<option value="0.526094712170968">1605</option> '
<option value="0.530728385116626">1606</option> '
<option value="0.542106375923075">1607</option> '
<option value="0.629125218456933">1608</option> '
<option value="0.639628233399717">1609</option> '
<option value="0.565426559943448">1610</option> '
<option value="0.582343149534473">1611</option> '
<option value="0.612273889018153">1612</option> '
<option value="0.646621446856314">1613</option> '
<option value="0.637295058288329">1614</option> '
<option value="0.618577348218317">1615</option> '
<option value="0.628489687796059">1616</option> '
<option value="0.640872541489573">1617</option> '
<option value="0.639973454823883">1618</option> '
<option value="0.591287924328729">1619</option> '
<option value="0.554825970708193">1620</option> '
<option value="0.58820511919027">1621</option> '
<option value="0.669996589469603">1622</option> '
<option value="0.65212507938361">1623</option> '
<option value="0.627768249538653">1624</option> '
<option value="0.651718083423443">1625</option> '
<option value="0.651563165413711">1626</option> '
<option value="0.597931053212445">1627</option> '
<option value="0.591417199388497">1628</option> '
<option value="0.616717027110516">1629</option> '
<option value="0.721523591753115">1630</option> '
<option value="0.778552341695596">1631</option> '
<option value="0.713345291175647">1632</option> '
<option value="0.700295371986784">1633</option> '
<option value="0.710611689905126">1634</option> '
<option value="0.714275831714696">1635</option> '
<option value="0.732575045079549">1636</option> '
<option value="0.741100738662297">1637</option> '
<option value="0.770171540447972">1638</option> '
<option value="0.69625900243602">1639</option> '
<option value="0.653370764117855">1640</option> '
<option value="0.712164682317266">1641</option> '
<option value="0.675195046376555">1642</option> '
<option value="0.690292565125841">1643</option> '
<option value="0.677279988899564">1644</option> '
<option value="0.689587010876459">1645</option> '
<option value="0.722896544912448">1646</option> '
<option value="0.848496656060524">1647</option> '
<option value="0.930846753205297">1648</option> '
<option value="0.910200915066942">1649</option> '
<option value="0.879448542152837">1650</option> '
<option value="0.8502189806341">1651</option> '
<option value="0.764957291172301">1652</option> '
<option value="0.705265085699157">1653</option> '
<option value="0.614649719442349">1654</option> '
<option value="0.594847273358658">1655</option> '
<option value="0.687800538630364">1656</option> '
<option value="0.72501961386337">1657</option> '
<option value="0.788825916836093">1658</option> '
<option value="0.843730828081639">1659</option> '
<option value="0.79457782573957">1660</option> '
<option value="0.852878965120187">1661</option> '
<option value="0.872433047596273">1662</option> '
<option value="0.778527937215427">1663</option> '
<option value="0.775177691344904">1664</option> '
<option value="0.729693085618103">1665</option> '
<option value="0.680824913995938">1666</option> '
<option value="0.665255890533809">1667</option> '
<option value="0.668949355402237">1668</option> '
<option value="0.733057544924699">1669</option> '
<option value="0.7175190265512">1670</option> '
<option value="0.721217467566075">1671</option> '
<option value="0.691984061185961">1672</option> '
<option value="0.733088241809524">1673</option> '
<option value="0.836287131478548">1674</option> '
<option value="0.791332915461366">1675</option> '
<option value="0.680506761958123">1676</option> '
<option value="0.720838779370823">1677</option> '
<option value="0.762318032609282">1678</option> '
<option value="0.776350665937669">1679</option> '
<option value="0.720771414454911">1680</option> '
<option value="0.748540201897444">1681</option> '
<option value="0.737277685477782">1682</option> '
<option value="0.72910277930131">1683</option> '
<option value="0.738095462891591">1684</option> '
<option value="0.772967289102821">1685</option> '
<option value="0.678955753830149">1686</option> '
<option value="0.667344452114472">1687</option> '
<option value="0.638980092283834">1688</option> '
<option value="0.628438364399026">1689</option> '
<option value="0.657987540783583">1690</option> '
<option value="0.641499632546994">1691</option> '
<option value="0.743471747249758">1692</option> '
<option value="0.829899454655459">1693</option> '
<option value="0.82024832829772">1694</option> '
<option value="0.770140131987654">1695</option> '
<option value="0.846248188232676">1696</option> '
<option value="0.8708055643328">1697</option> '
<option value="0.926805979355216">1698</option> '
<option value="0.856709138973226">1699</option> '
<option value="0.777649851025718">1700</option> '
<option value="0.702514813327469">1701</option> '
<option value="0.685856173367716">1702</option> '
<option value="0.661151477744294">1703</option> '
<option value="0.717788633541333">1704</option> '
<option value="0.6776525599891">1705</option> '
<option value="0.668594527709535">1706</option> '
<option value="0.66531602439165">1707</option> '
<option value="0.713862650310244">1708</option> '
<option value="0.893798158751969">1709</option> '
<option value="0.937406458525094">1710</option> '
<option value="0.8400021623972">1711</option> '
<option value="0.773895602042877">1712</option> '
<option value="0.778207269599252">1713</option> '
<option value="0.818029170228218">1714</option> '
<option value="0.731569757383545">1715</option> '
<option value="0.777641640567023">1716</option> '
<option value="0.761979142611156">1717</option> '
<option value="0.73056290519921">1718</option> '
<option value="0.708804271022807">1719</option> '
<option value="0.773213784136439">1720</option> '
<option value="0.742073313427774">1721</option> '
<option value="0.721973285087467">1722</option> '
<option value="0.728314827048595">1723</option> '
<option value="0.727755397376278">1724</option> '
<option value="0.775395291688852">1725</option> '
<option value="0.806552140899545">1726</option> '
<option value="0.783616798621161">1727</option> '
<option value="0.88594217265609">1728</option> '
<option value="0.833958625850188">1729</option> '
<option value="0.743533355607403">1730</option> '
<option value="0.687496781731366">1731</option> '
<option value="0.646337529209174">1732</option> '
<option value="0.670978796320216">1733</option> '
<option value="0.708231297581869">1734</option> '
<option value="0.73763220258921">1735</option> '
<option value="0.740512397873575">1736</option> '
<option value="0.710966450714382">1737</option> '
<option value="0.685591204612798">1738</option> '
<option value="0.714876300009278">1739</option> '
<option value="0.818377575069495">1740</option> '
<option value="0.846969753914682">1741</option> '
<option value="0.727021496268972">1742</option> '
<option value="0.664283262056874">1743</option> '
<option value="0.642030901514897">1744</option> '
<option value="0.673546494767931">1745</option> '
<option value="0.726515903423794">1746</option> '
<option value="0.707400625594956">1747</option> '
<option value="0.728325592253141">1748</option> '
<option value="0.724168660795105">1749</option> '
<option value="0.72056838380211">1750</option> '
<option value="0.706439591962852">1751</option> '
<option value="0.734697175641367">1752</option> '
<option value="0.72056838380211">1753</option> '
<option value="0.748825967480624">1754</option> '
<option value="0.706439591962852">1755</option> '
<option value="0.734697175641367">1756</option> '
<option value="0.890113885873194">1757</option> '
<option value="0.890113885873194">1758</option> '
<option value="0.819469926676909">1759</option> '
<option value="0.791212342998395">1760</option> '
<option value="0.748825967480624">1761</option> '
<option value="0.777083551159138">1762</option> '
<option value="0.805341134837652">1763</option> '
<option value="0.875985094033937">1764</option> '
<option value="0.904242677712451">1765</option> '
<option value="0.918371469551708">1766</option> '
<option value="0.96075784506948">1767</option> '
<option value="0.946629053230223">1768</option> '
<option value="0.875985094033937">1769</option> '
<option value="0.875985094033937">1770</option> '
<option value="0.946629053230223">1771</option> '
<option value="1.04553059610502">1772</option> '
<option value="1.04553059610502">1773</option> '
<option value="1.05965938794428">1774</option> '
<option value="0.989015428747994">1775</option> '
<option value="0.974886636908737">1776</option> '
<option value="0.974886636908737">1777</option> '
<option value="1.00314422058725">1778</option> '
<option value="0.918371469551709">1779</option> '
<option value="0.890113885873195">1780</option> '
<option value="0.932500261390966">1781</option> '
<option value="0.946629053230223">1782</option> '
<option value="1.05965938794428">1783</option> '
<option value="1.07378817978354">1784</option> '
<option value="1.01727301242651">1785</option> '
<option value="1.01727301242651">1786</option> '
<option value="1.01727301242651">1787</option> '
<option value="1.05965938794428">1788</option> '
<option value="1.04553059610502">1789</option> '
<option value="1.05965938794428">1790</option> '
<option value="1.05965938794428">1791</option> '
<option value="1.07378817978354">1792</option> '
<option value="1.10204576346205">1793</option> '
<option value="1.20094730633685">1794</option> '
<option value="1.32810643289016">1795</option> '
<option value="1.41287918392571">1796</option> '
<option value="1.27159126553313">1797</option> '
<option value="1.24333368185462">1798</option> '
<option value="1.39875039208645">1799</option> '
<option value="1.9073868982997">1800</option> '
<option value="2.13344756772782">1801</option> '
<option value="1.63893985335382">1802</option> '
<option value="1.55416710231828">1803</option> '
<option value="1.59655347783605">1804</option> '
<option value="1.85087173094267">1805</option> '
<option value="1.78022777174639">1806</option> '
<option value="1.73784139622862">1807</option> '
<option value="1.8084853554249">1808</option> '
<option value="1.97803085749599">1809</option> '
<option value="2.03454602485302">1810</option> '
<option value="1.97803085749599">1811</option> '
<option value="2.24647790244187">1812</option> '
<option value="2.3029930697989">1813</option> '
<option value="2.0062884411745">1814</option> '
<option value="1.79435656358565">1815</option> '
<option value="1.63893985335382">1816</option> '
<option value="1.86500052278193">1817</option> '
<option value="1.86500052278193">1818</option> '
<option value="1.82261414726416">1819</option> '
<option value="1.65306864519308">1820</option> '
<option value="1.45526555944348">1821</option> '
<option value="1.25746247369388">1822</option> '
<option value="1.34223522472942">1823</option> '
<option value="1.45526555944348">1824</option> '
<option value="1.7095838125501">1825</option> '
<option value="1.6106822696753">1826</option> '
<option value="1.51178072680051">1827</option> '
<option value="1.46939435128273">1828</option> '
<option value="1.45526555944348">1829</option> '
<option value="1.39875039208645">1830</option> '
<option value="1.54003831047902">1831</option> '
<option value="1.42700797576496">1832</option> '
<option value="1.34223522472942">1833</option> '
<option value="1.22920489001536">1834</option> '
<option value="1.25746247369388">1835</option> '
<option value="1.39875039208645">1836</option> '
<option value="1.42700797576496">1837</option> '
<option value="1.44113676760422">1838</option> '
<option value="1.54003831047902">1839</option> '
<option value="1.56829589415753">1840</option> '
<option value="1.54003831047902">1841</option> '
<option value="1.41287918392571">1842</option> '
<option value="1.25746247369388">1843</option> '
<option value="1.25746247369388">1844</option> '
<option value="1.31397764105091">1845</option> '
<option value="1.37049280840794">1846</option> '
<option value="1.54003831047902">1847</option> '
<option value="1.34223522472942">1848</option> '
<option value="1.25746247369388">1849</option> '
<option value="1.18681851449759">1850</option> '
<option value="1.14443213897982">1851</option> '
<option value="1.14443213897982">1852</option> '
<option value="1.25746247369388">1853</option> '
<option value="1.44113676760422">1854</option> '
<option value="1.48352314312199">1855</option> '
<option value="1.48352314312199">1856</option> '
<option value="1.41287918392571">1857</option> '
<option value="1.28572005737239">1858</option> '
<option value="1.27159126553314">1859</option> '
<option value="1.31397764105091">1860</option> '
<option value="1.34223522472942">1861</option> '
<option value="1.31397764105091">1862</option> '
<option value="1.27159126553314">1863</option> '
<option value="1.25746247369388">1864</option> '
<option value="1.27159126553314">1865</option> '
<option value="1.34223522472942">1866</option> '
<option value="1.42700797576496">1867</option> '
<option value="1.41287918392571">1868</option> '
<option value="1.34223522472942">1869</option> '
<option value="1.34223522472942">1870</option> '
<option value="1.35636401656868">1871</option> '
<option value="1.41287918392571">1872</option> '
<option value="1.46939435128273">1873</option> '
<option value="1.41287918392571">1874</option> '
<option value="1.38462160024719">1875</option> '
<option value="1.38462160024719">1876</option> '
<option value="1.37049280840794">1877</option> '
<option value="1.34223522472942">1878</option> '
<option value="1.28572005737239">1879</option> '
<option value="1.32810643289016">1880</option> '
<option value="1.31397764105091">1881</option> '
<option value="1.32810643289016">1882</option> '
<option value="1.31397764105091">1883</option> '
<option value="1.28572005737239">1884</option> '
<option value="1.24333368185462">1885</option> '
<option value="1.22920489001536">1886</option> '
<option value="1.21507609817611">1887</option> '
<option value="1.22920489001536">1888</option> '
<option value="1.24333368185462">1889</option> '
<option value="1.24333368185462">1890</option> '
<option value="1.25746247369388">1891</option> '
<option value="1.25746247369388">1892</option> '
<option value="1.24333368185462">1893</option> '
<option value="1.22920489001536">1894</option> '
<option value="1.21507609817611">1895</option> '
<option value="1.20094730633685">1896</option> '
<option value="1.22920489001537">1897</option> '
<option value="1.22920489001537">1898</option> '
<option value="1.24333368185462">1899</option> '
<option value="1.29984884921165">1900</option> '
<option value="1.29984884921165">1901</option> '
<option value="1.29984884921165">1902</option> '
<option value="1.31397764105091">1903</option> '
<option value="1.31397764105091">1904</option> '
<option value="1.31397764105091">1905</option> '
<option value="1.31397764105091">1906</option> '
<option value="1.32810643289017">1907</option> '
<option value="1.32810643289017">1908</option> '
<option value="1.34223522472942">1909</option> '
<option value="1.35636401656868">1910</option> '
<option value="1.35636401656868">1911</option> '
<option value="1.39875039208645">1912</option> '
<option value="1.38462160024719">1913</option> '
<option value="1.38462160024719">1914</option> '
<option value="1.55416710231828">1915</option> '
<option value="1.83674293910342">1916</option> '
<option value="2.3029930697989">1917</option> '
<option value="2.81162957601216">1918</option> '
<option value="3.0942054127973">1919</option> '
<option value="3.57458433533204">1920</option> '
<option value="3.26375091486838">1921</option> '
<option value="2.81162957601216">1922</option> '
<option value="2.64208407394107">1923</option> '
<option value="2.62795528210182">1924</option> '
<option value="2.62795528210182">1925</option> '
<option value="2.61382649026256">1926</option> '
<option value="2.54318253106627">1927</option> '
<option value="2.54318253106627">1928</option> '
<option value="2.51492494738776">1929</option> '
<option value="2.44428098819147">1930</option> '
<option value="2.34537944531668">1931</option> '
<option value="2.28886427795965">1932</option> '
<option value="2.23234911060262">1933</option> '
<option value="2.23234911060262">1934</option> '
<option value="2.24647790244188">1935</option> '
<option value="2.26060669428113">1936</option> '
<option value="2.34537944531668">1937</option> '
<option value="2.37363702899519">1938</option> '
<option value="2.44428098819148">1939</option> '
<option value="2.85401595152993">1940</option> '
<option value="3.16484937199359">1941</option> '
<option value="3.3909100414217">1942</option> '
<option value="3.50394037613576">1943</option> '
<option value="3.60284191901056">1944</option> '
<option value="3.70174346188536">1945</option> '
<option value="3.81477379659941">1946</option> '
<option value="4.0832208415453">1947</option> '
<option value="4.39405426200895">1948</option> '
<option value="4.52121338856227">1949</option> '
<option value="4.66672995724212">1950</option> '
<option value="5.0570407536077">1951</option> '
<option value="5.51398997862106">1952</option> '
<option value="5.69486571352218">1953</option> '
<option value="5.8118229556387">1954</option> '
<option value="6.07429676643506">1955</option> '
<option value="6.37688963121326">1956</option> '
<option value="6.59516448423303">1957</option> '
<option value="6.78420002672368">1958</option> '
<option value="6.82839898450027">1959</option> '
<option value="6.89367744521646">1960</option> '
<option value="7.11399225013362">1961</option> '
<option value="7.40094548369856">1962</option> '
<option value="7.56278166755746">1963</option> '
<option value="7.80009607161945">1964</option> '
<option value="8.15912760555852">1965</option> '
<option value="8.49231974879743">1966</option> '
<option value="8.6691155799038">1967</option> '
<option value="9.03222701763763">1968</option> '
<option value="9.50685582576162">1969</option> '
<option value="10.0712425173704">1970</option> '
<option value="10.929382282202">1971</option> '
<option value="11.6630849812934">1972</option> '
<option value="12.7041404329236">1973</option> '
<option value="14.5700164350615">1974</option> '
<option value="17.784980625334">1975</option> '
<option value="20.4994766167825">1976</option> '
<option value="23.5111256012827">1977</option> '
<option value="25.2763639764832">1978</option> '
<option value="28.0547784607162">1979</option> '
<option value="32.1924808925708">1980</option> '
<option value="35.8317550774987">1981</option> '
<option value="38.7427664350615">1982</option> '
<option value="40.6276819882416">1983</option> '
<option value="42.4112799305184">1984</option> '
<option value="44.5994683324425">1985</option> '
<option value="46.2477494655265">1986</option> '
<option value="47.7539139497595">1987</option> '
<option value="49.61775">1988</option> '
<option value="52.2058333333333">1989</option> '
<option value="55.8595833333333">1990</option>' 
<option value="60.05975">1991</option> '
<option value="62.6015">1992</option> '
<option value="64.1875">1993</option> '
<option value="65.46725">1994</option> '
<option value="67.1890833333333">1995</option> '
<option value="68.8185">1996</option> '
<option value="70.0741666666667">1997</option> '
<option value="71.1655">1998</option> '
<option value="72.1110833333333">1999</option> '
<option value="72.6854166666667">2000</option> '
<option value="73.582">2001</option> '
<option value="74.5083333333333">2002</option> '
<option value="75.5228333333333">2003</option> '
<option value="76.5375">2004</option> '
<option value="78.1118333333333">2005</option> '
<option value="79.9308333333333">2006</option> '
<option value="81.7875">2007</option> '
<option value="84.7334166666667">2008</option> '
<option value="86.5681666666667">2009</option> '
<option value="89.4233333333333">2010</option> '
<option value="93.4149166666667">2011</option> '
<option value="96.0569166666667">2012</option> '
<option value="98.5205833333333">2013</option> '
<option value="99.96">2014</option> '
<option value="100.000083333333">2015</option> '
<option value="100.65975">2016</option> '
<option value="103.360583333333">2017</option> '
<option value="105.921916666667">2018</option> '
<option value="107.819">2019</option> '
<option value="108.736166666667">2020</option> '
<option value="111.5505">2021</option> '
<option value="114.898">Jan 22</option>'
<option value="115.827">Feb 22</option>'
<option value="117.094">Mar 22</option>'
<option value="120.036">Apr 22</option>'
<option value="120.82">May 22</option>'
<option value="121.791">Jun 22</option>'
<option value="122.539">Jul 22</option>'
<option value="123.148">Aug 22</option>'
<option value="123.764">Sep 22</option>'
<option value="126.199">Oct 22</option>	'		
<option value="126.694">Nov 22</option>	'`.replaceAll(regex, '').replaceAll('/>', ',').replaceAll('>', ',').split(',')

let objData = {}

newData.forEach((item, index) => {
    let date = newData[index + 1]
    if(index % 2 === 0 && date >= 1800){
        objData[date] = Number(item)
    } 
});

export default objData